<template>
  <b-row class="dynrow" >
    <template v-for="(widget, index) in widgetData.widgets">
      <b-col class="column" :cols="widget.columns" :key="index">
        <widget-inner :widget-data="widget" ref="childWidgets"/>
      </b-col>
    </template>
  </b-row>
</template>

<script>

export default {
  name: 'RowWidget',

    components: {
        'widget-inner': () => import('./Widget.vue')
    },

    data() {
        return {}
  },

  props: {
    widgetData: Object
  },

  methods: {
    requestData(requester) {
//      console.log("Ok - RowWidget call children with requester");
      for(const cw of this.$refs.childWidgets) {
        cw.requestData(requester);
      }

    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .column {
    /*background-color: #dddddd;*/
}
  .dynrow {
    margin-top: 1em;
  }


</style>
